import styled from "styled-components";
import { Blank, Flex, Icon, IconButton, IconButtonButton } from "@evergis/ui";

export const ExternalLink = styled(IconButton)`
  ${Icon} {
    color: ${({ theme: { palette } }) => palette.primary};
  }

  &:hover ${Icon} {
    color: ${({ theme: { palette } }) => palette.primaryDeep};
  }
`;
ExternalLink.defaultProps = { kind: "external_link" };

export const LocalLinkBlank = styled(Blank)`
  min-width: 13.5rem;
  padding: 0.5rem 0.75rem 0;

  a {
    text-decoration: none;
    font-size: 0.75rem;
    color: ${({ theme: { palette } }) => palette.primary};
  }

  ${IconButtonButton} {
    font-size: 0.75rem;
  }
`;

export const LocalLinkButton = styled(IconButton)`
  width: 1rem;
  height: 1rem;
  background-color: ${({ theme: { palette } }) => palette.primary};
  border-radius: 50%;

  span[kind] {
    display: flex;
    justify-content: center;
    align-items: center;

    :after {
      position: relative;
      font-size: 0.6rem;
      color: white;
    }
  }
`;
LocalLinkButton.defaultProps = { kind: "link" };

export const LocalLinkCopy = styled(Flex)`
  justify-content: center;
`;
